import { createTeamResourceContext } from './createTeamResourceContext'
import useTeamDeploymentsResources from '../shared/resources/api/v1/admin/docker/useTeamDeploymentsResources'
import { useDeploymentEvents } from '../shared/websocket'
import useThrottledCallback from '../shared/hooks/useThrottledCallback'

const { Provider: BaseDeploymentsProvider, useHook: useDeployments } = createTeamResourceContext({
  name: 'Deployments',
  useResources: useTeamDeploymentsResources,
  responseKey: 'deployments',
  requestOptions: { params: { latest: 'true' } },
  lookups: [
    { key: 'deploymentsById', field: 'id' },
    { key: 'deploymentsByDeployableId', field: 'deployableId' },
  ],
  polling: false,
})

function DeploymentEventSubscriber({ children }) {
  const { reload } = useDeployments()
  const throttledReload = useThrottledCallback(reload)

  useDeploymentEvents({
    onCreated: throttledReload,
    onUpdated: throttledReload,
  })

  return children
}

function DeploymentsProvider({ children }) {
  return (
    <BaseDeploymentsProvider>
      <DeploymentEventSubscriber>
        {children}
      </DeploymentEventSubscriber>
    </BaseDeploymentsProvider>
  )
}

export { DeploymentsProvider, useDeployments }
